import { render, staticRenderFns } from "./OfferDetailsHeader.vue?vue&type=template&id=16481140&"
import script from "./OfferDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./OfferDetailsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports